import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import flexbox from 'styles/utils/flexbox';
import { mediaQueries, dynamicCss } from 'styles/utils/mediaQueries';

const defaultProps = {
  imageOverlay: true,
  styles: {},
};

function PromoHeaderComponent({
  image,
  imageOverlay,
  title,
  subtitle,
  tagline,
  buttonLabel,
  hashLinkTo,
  onClickButton,
  styles,
}) {
  return (
    <Root>
      <BackgroundImage image={image} imageOverlay={imageOverlay} styles={styles.backgroundImage}>
        <ContentWrap>
          <Title styles={styles.title}>{title}</Title>
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
          {tagline && <Tagline>{tagline}</Tagline>}
          {onClickButton && <Button onClick={onClickButton}>{buttonLabel}</Button>}
          {hashLinkTo && (
            <Link href={`#${hashLinkTo}`}>
              <a href={`#${hashLinkTo}`}>
                <Button>{buttonLabel}</Button>
              </a>
            </Link>
          )}
        </ContentWrap>
      </BackgroundImage>
    </Root>
  );
}

PromoHeaderComponent.defaultProps = defaultProps;

export default PromoHeaderComponent;

const Root = styled.div``;

const BackgroundImage = styled.div`
  ${flexbox({
    justifyContent: 'center',
  })}

  position: relative;
  height: 50vh;
  background: ${({ image, imageOverlay }) =>
    imageOverlay
      ? `linear-gradient(rgba(0,0,0,0),rgba(0,0,0,0.2),rgba(0,0,0,0.6),rgba(0,0,0,0.7)), url(${image})`
      : `url(${image})`};
  background-size: cover;
  background-position: center;

  ${mediaQueries.fromAndAbove.tablet`
    height: 86vh;
  `}

  ${({ styles }) => styles && styles.map(dynamicCss)}
`;

const ContentWrap = styled.div`
  ${flexbox({
    flexDirection: 'column',
    alignItems: 'center',
  })}

  max-width: 90vw;
  position: absolute;
  bottom: -22px;
  text-align: center;

  ${mediaQueries.fromAndAbove.desktop`
    max-width: 860px;
  `}
`;

const Title = styled.div`
  margin: 0 0 6px 0;
  font-family: ${(props) => props.theme.fonts.display};
  font-size: 4.5em;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.white};

  ${mediaQueries.fromAndAbove.tablet`
    margin: 0 0 32px 0;
    font-size: 9.2em;
  `}

  ${({ styles }) => styles && styles.map(dynamicCss)}
`;

const Subtitle = styled.div`
  margin: 0 0 15px 0;
  font-size: 1.6em;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: ${({ theme }) => theme.colors.text.white};
  opacity: 0.8;

  ${mediaQueries.fromAndAbove.tablet`
    margin: 0 0 32px 0;
  `}
`;

const Tagline = styled.div`
  margin: 0 0 15px 0;
  font-size: 1.6em;
  font-weight: 500;
  line-height: 1.66;
  color: ${({ theme }) => theme.colors.text.white};

  ${mediaQueries.fromAndAbove.tablet`
    margin: 0 0 32px 0;
  `}
`;

const Button = styled.button`
  padding: 12px 40px;
  background-color: ${({ theme }) => theme.colors.text.white};
  border: 0;
  border-radius: 4px;
  font-size: 1.8em;
  font-weight: bold;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.adjacent.default};
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  transition: all 350ms ease-out;

  &:hover {
    transform: translateY(-3px);
  }

  &:active {
    transition: all 150ms ease-in;
    transform: translateY(3px);
  }
`;
